function Article10() {
    return (
      <div className="article">
          <h1></h1>
          <p></p>
      </div>
    );
  }
  
  export default Article10;